import { useState, useRef, useEffect } from 'react'
import { useMount } from 'ahooks'
import { useNavigate } from 'react-router-dom'
import styles from './index.module.less'
import { routesMap } from '@/router/routes'
import Tabbar from '@/components/Tabbar/Tabbar'
import SearchBar1688 from '@/pages/Products1688/components/SearchBar'
import Icon from '@/components/Icon/Icon'
import { OpenSource } from '@/constant/base-const'
import localStorage from '@/utils/localStorage'
import Banner from './components/Banner/Banner'
import BannerDefault from './components/Banner/BannerDefault'
import Nav1 from './components/Nav1/Nav1'
import Nav2 from './components/Nav2/Nav2'
import Products from './components/Products/Products'
import useCorpInfoStore from '@/stores/corp-info'
import Marquee from '@/components/Marquee/Index'
import { utils, uploadEt } from '@/utils'
import common from '@/utils/common'
import apis from '@/apis'
import type { ModuleItemProps } from '@/types/interfaces'
import OtherModule from './components/OtherModule/OtherModule'
import AllProducts from './components/AllProducts/AllProducts'
import Products1688 from '@/pages/Products1688/components/Products'

const { getLocalStorage } = localStorage
const { to } = utils
const { checkCorpChange } = common
const { corpApi } = apis

function App() {
  const { corpInfo, setCorpInfo } = useCorpInfoStore()
  const { corpId, industryId } = corpInfo
  const navigate = useNavigate()
  const openSource = getLocalStorage('openSource')
  const [modules, setModules] = useState<ModuleItemProps[]>([]) // 首屏模块
  const [otherModules, setOtherModules] = useState<ModuleItemProps[]>([]) // 其他模块
  const searchBarDom = useRef<HTMLDivElement>(null)
  const [searchBarHeight, setSearchBarHeight] = useState(0)
  const [isLoadingProducts, setIsLoadingProducts] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [filter, setFilter] = useState({
    sortKey: 'monthSold',
    sortDirection: 'desc',
  })
  const [imageId, setImageId] = useState('')

  const [cloudStoreNotice, setCloudStoreNotice] = useState('')

  checkCorpChange()

  function openMenuModal() {
    if (
      window.webview?.openDrawerMenu &&
      typeof window.webview.openDrawerMenu === 'function'
    )
      window.webview.openDrawerMenu()
  }

  // const handleScanSearch = () => {
  //   // 唤起 app 扫码
  //   if (window.webview && window.webview.scan) {
  //     window.webview.scan()
  //   }
  // }
  // // 获取 App 扫码结果
  // const getScanValue = (text: string) => {
  //   navigate(`/products/search?text=${text}`)
  // }
  // window.getScanValue = getScanValue

  useMount(() => {
    uploadEt({ event_type: 2 }) // 埋点，首页浏览次数
    getCloudStoreNotice()
    getHomeModule()
  })

  useEffect(() => {
    if (searchBarDom.current) {
      setSearchBarHeight(searchBarDom.current.offsetHeight)
    }
  }, [modules])

  // 查询店铺公告
  async function getCloudStoreNotice() {
    const params = { corpId, publishStatus: 1, industryId }
    const [err, res] = await to(corpApi.getCloudStorePersonalInfo(params))

    if (err) {
      return
    }

    const { noticeStatus, notice } = res?.data || {}

    if (noticeStatus === 1 && notice) {
      setCloudStoreNotice(notice)
      setCorpInfo({ ...corpInfo, cloudStoreNotice: notice })
    } else {
      setCorpInfo({ ...corpInfo, cloudStoreNotice: '' })
    }
  }

  /*
   * 获取首页模块
   */
  async function getHomeModule() {
    const params = { corpId, publishStatus: 1, industryId }

    const [err, res] = await to(corpApi.queryHomeModule(params))

    if (err) return

    // 筛选出已发布的模块
    const modules = (res?.data || [])
      .filter((module: any) => module.publishStatus === 1)
      .filter((module: any) => module.type !== 3) // 过滤掉产品模块
      .sort((a: { sort: number }, b: { sort: number }) => a.sort - b.sort)

    if (!modules.length) {
      navigate(routesMap.Products, {
        replace: true,
      })
      return
    }

    setModules(modules.splice(0, 5))
    setOtherModules(modules)
    setIsLoadingProducts(true)
  }

  const renderedModules = modules.map((item: ModuleItemProps) => {
    return (
      <div key={item.corpModuleId}>
        {item.type === 0 && <Banner module={item} />}
        {item.type === 1 && <Nav1 module={item} />}
        {item.type === 2 && <Nav2 module={item} />}
        {item.type === 3 && <Products module={item} />}
      </div>
    )
  })

  // 如果第1个模块不是banner模块，则在第1个模块前面插入默认banner图片
  if (modules.length && modules[0].type !== 0) {
    renderedModules.unshift(
      <div key="BannerDefault">
        <BannerDefault />
      </div>,
    )
  }

  const bannerModule = renderedModules.shift()

  /* 设置顶栏颜色 */
  useEffect(() => {
    if (
      window.webview?.setNotificationColor &&
      typeof window.webview.setNotificationColor === 'function'
    ) {
      window.webview?.setNotificationColor('#fe5700')
    }

    return () => {
      if (
        window.webview?.setNotificationColor &&
        typeof window.webview.setNotificationColor === 'function'
      ) {
        window.webview?.setNotificationColor('#ffffff')
      }
    }
  }, [])

  /* 页面渲染 */
  if (!modules.length) {
    return null
  }
  return (
    <div
      className={styles['home-wrap']}
      style={{
        paddingTop: `${searchBarHeight}px`,
      }}
    >
      {/* 头部，包含搜索栏、模块1、公告栏 */}
      <div className={styles['home-header']}>
        {/* 搜索栏 */}
        <div className={styles['searchbar-box']} ref={searchBarDom}>
          {openSource === OpenSource.APP && (
            <Icon
              name="menu"
              className={styles['more-menu']}
              size={40}
              onClick={openMenuModal}
            />
          )}

          <SearchBar1688
            className={styles['search-bar']}
            customizeStyle={{ backgroundColor: 'white' }}
            onSearch={setSearchText}
            onImageChoose={setImageId}
            onFilter={setFilter}
          />
        </div>

        {/* 模块1 */}
        {!(searchText || imageId) && bannerModule}
      </div>

      {searchText || imageId ? (
        <Products1688
          searchText={searchText}
          imageId={imageId}
          filter={filter}
        />
      ) : (
        <>
          {/* 公告栏 */}
          {cloudStoreNotice && (
            <div key="cloudStoreNotice">
              <Marquee text={cloudStoreNotice} />
            </div>
          )}
          <div className={styles['home-bd']} id="J_homeBd">
            <div className={styles['customize-warp']}>
              {renderedModules.map((item) => item)}

              <OtherModule list={otherModules} />
              {isLoadingProducts && (
                <div>
                  <AllProducts />
                </div>
              )}
            </div>
          </div>
        </>
      )}

      {/* 底部工具栏 */}
      <Tabbar></Tabbar>
    </div>
  )
}

export default App
